module.exports = __webpack_public_path__ + "img/toggle-01-right.06b13fa7.svg";